<template>
  <svg width="55" height="69" viewBox="0 0 55 69" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_80_46779)">
      <path d="M14.2938 67.002H52.7671V21.9189C46.0055 15.1347 38.835 7.94026 32.9562 2.04175C26.1081 2.07959 9.16817 2.06182 2.28711 2.06182V57.0042H11.2156" stroke="white" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"/>
      <path d="M52.4014 21.4364H31.7014V2.97485" stroke="white" stroke-width="3" stroke-miterlimit="10"/>
      <path d="M20.3228 45.3831L27.2228 52.3061L34.1228 45.3831" stroke="white" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"/>
      <path d="M27.1499 51.5386V28.4617" stroke="white" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"/>
    </g>
    <defs>
      <clipPath id="clip0_80_46779">
        <rect width="55" height="69" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>
